var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navMenus.length)?_c('div',{staticClass:"navbar-links"},_vm._l((_vm.navMenus),function(item,index){return _c('div',{key:index,staticClass:"navbar-links__item"},[(item.type === 'links')?_c('DropdownLink',{attrs:{"item":item}}):_c('NavLink',{attrs:{"item":item}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }